import { Link } from "@tanstack/react-router";
import { DISCIPLINES } from "@/lib/disciplines";
import { GenerateCta } from "@/components/generate-cta";
import { BRAND_NAME } from "@/lib/brand";

export function SiteFooter() {
  return (
    <footer className="no-print mt-24 border-t border-border/60 bg-secondary/40">
      <div className="mx-auto flex max-w-6xl flex-col gap-6 px-4 py-8 text-sm text-muted-foreground sm:px-6">
        <div className="flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between">
          <p>
            © 2026 {BRAND_NAME} · dealdraft.pro ·{" "}
            <a href="mailto:support@dealdraft.pro" className="hover:text-foreground">
              support@dealdraft.pro
            </a>
          </p>
          <nav className="flex flex-wrap gap-5">
            <Link to="/" className="hover:text-foreground">
              Home
            </Link>
            <Link to="/guides" className="hover:text-foreground">
              Guides
            </Link>
            <GenerateCta unstyled className="cursor-pointer hover:text-foreground">
              Generate
            </GenerateCta>
            <Link to="/pricing" className="hover:text-foreground">
              Pricing
            </Link>
            <Link to="/login" className="hover:text-foreground">
              Login
            </Link>
            <Link to="/about" className="hover:text-foreground">
              About
            </Link>
            <Link to="/privacy" className="hover:text-foreground">
              Privacy Policy
            </Link>
            <Link to="/terms" className="hover:text-foreground">
              Terms of Service
            </Link>
            <Link to="/contact" className="hover:text-foreground">
              Contact
            </Link>
          </nav>
        </div>
        <nav className="flex flex-wrap items-center gap-x-5 gap-y-2 border-t border-border/60 pt-6">
          <span className="text-xs font-medium uppercase tracking-wide text-muted-foreground/70">
            Proposal templates by industry:
          </span>
          {DISCIPLINES.map((d) => (
            <Link
              key={d.slug}
              to="/for/$slug"
              params={{ slug: d.slug }}
              className="hover:text-foreground"
            >
              {d.label}
            </Link>
          ))}
        </nav>
        <p className="text-xs">Not legal advice. Templates only.</p>
      </div>
    </footer>
  );
}
